module.exports = __webpack_public_path__ + "img/pydantic.e4e81be1.svg";